import React, { useState, useEffect } from 'react'
import { useQuery, useLazyQuery } from '@apollo/client'
import { useAlert } from 'react-alert'
import sortBy from 'lodash/sortBy'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Filters from './components/Filters'
import EngagementUsersGrid from './components/EngagementUsersGrid'
import EngagementQuartileGraph from '../ProgressPage/components/EngagementQuartileGraph'
import { useStyles } from './styles'
import { GET_USERS_LIST } from '../../network/management/queries'
import { GET_WAVES_LIST, GET_ENGAGEMENT_DATA } from '../../network/progress/queries'
import { ALL_TIME_PERIOD_FILTER } from '../../constants/common'

const Engagement = () => {
  const classes = useStyles()
  const alert = useAlert()
  const [waveFilterValue, setWaveFilterValue] = useState({ id: null, name: '' })
  const [periodFilterValue, setPeriodFilterValue] = useState(ALL_TIME_PERIOD_FILTER)
  const [users, setUsers] = useState([])
  const [engagementData, setEngagementData] = useState(null)

  const { loading: wavesLoading, data: wavesData } = useQuery(GET_WAVES_LIST, {
    fetchPolicy: 'no-cache',
    onError: error => {
      alert.show(error.message, {
        type: 'error'
      })
    },
    onCompleted: data => {
      setWaveFilterValue(sortBy(data.coordinator.wave.list, 'name')[0])
    }
  })

  const [getUsersList, { loading: usersLoading }] = useLazyQuery(GET_USERS_LIST, {
    fetchPolicy: 'no-cache',
    onError: error => {
      setUsers([])
      alert.show(error.message, {
        type: 'error'
      })
    },
    onCompleted: data => {
      setUsers(data.coordinator.user.list)
    }
  })

  const [getEngagementData, { loading: engagementLoading }] = useLazyQuery(GET_ENGAGEMENT_DATA, {
    fetchPolicy: 'no-cache',
    onError: error => {
      setUsers([])
      alert.show(error.message, {
        type: 'error'
      })
    },
    onCompleted: data => {
      setEngagementData(data)
    }
  })

  useEffect(() => {
    if (waveFilterValue.id) {
      getUsersList({
        variables: {
          waveIds: [waveFilterValue.id]
        }
      })

      getEngagementData({
        variables: {
          waveId: waveFilterValue.id
        }
      })
    }
  }, [waveFilterValue.id, getUsersList, getEngagementData])

  const handleWaveFilterChange = value => {
    setWaveFilterValue(value)
  }

  const handlePeriodFilterChange = value => {
    setPeriodFilterValue(value)
  }

  return wavesLoading || usersLoading || engagementLoading || !wavesData || !engagementData ? (
    <div className={classes.loader}>
      <CircularProgress color='inherit' />
    </div>
  ) : (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12}>
          <Typography variant='h2' component='div'>
            Engagement
          </Typography>
        </Grid>
        <Grid container item xs={12}>
          <div className={classes.container}>
            <Filters
              data={wavesData}
              waveFilterValue={waveFilterValue}
              handleWaveFilterChange={handleWaveFilterChange}
              periodFilterValue={periodFilterValue}
              handlePeriodFilterChange={handlePeriodFilterChange}
            />
            <EngagementQuartileGraph
              data={engagementData.coordinator.stats}
              selectedWave={wavesData.coordinator.wave.list.find(wave => waveFilterValue.id === wave.id)}
            />
            <EngagementUsersGrid data={users} />
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default Engagement
